// Third party
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: '',
  },
});

const AccountRootCreateUpdateSchema = yup.object().shape({
  name: yup.string().required(''),
  email: yup.string().required('').email().trim(),
  phone: yup.string().trim().required(''),
  account_type: yup.string().required(''),
});

export {
  AccountRootCreateUpdateSchema,
};
